import { BankOutlined, DollarOutlined, EditOutlined, GlobalOutlined, MailOutlined, PhoneOutlined, UserOutlined, SaveOutlined } from '@ant-design/icons'
import { Avatar, Button, Card, Col, Divider, Input, Row, Space, Statistic, Tag, Select, Switch } from 'antd'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import axiosInstance from '../../../../variables/api/axiosInstance'
import { LOGGED_USER } from '../../../../variables/constants'
import { peutModifierRetenueFiscale } from '../../../../services/rightsService'

const CourtierProfil = ({ courtier, setTCModalOpen, myAgreement }) => {
    const [tauxRetenue, setTauxRetenue] = useState(20);
    const [savingTaux, setSavingTaux] = useState(false);
    // Retenue fiscale : le Pool règle le taux PAR DÉFAUT (fiche du courtier, partagée par toutes les
    // compagnies) ; une compagnie règle SON taux, rangé sur sa convention avec le courtier (vide = elle
    // suit le taux du Pool). Administrateur du siège seulement.
    const estPool = LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL";
    const canEditTaux = peutModifierRetenueFiscale() && (estPool || !!myAgreement);
    const tauxPool = courtier?.tauxRetenueFiscale ?? 20;
    const tauxCompagnie = myAgreement?.tauxRetenueFiscale;
    // Base de commission : false = prime nette seule (défaut), true = prime nette + accessoires.
    const [commAccessoires, setCommAccessoires] = useState(false);
    const [savingComm, setSavingComm] = useState(false);

    // Édition du responsable + des contacts (réparation des données manquantes). Réservé au Pool.
    const canEditInfos = LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL";
    const [responsable, setResponsable] = useState("");
    const [editingResp, setEditingResp] = useState(false);
    const [savingResp, setSavingResp] = useState(false);
    const [contacts, setContacts] = useState(["", ""]);
    const [editingContacts, setEditingContacts] = useState(false);
    const [savingContacts, setSavingContacts] = useState(false);

    useEffect(() => {
        setCommAccessoires(!!courtier?.commissionAvecAccessoires);
        setResponsable((courtier?.responsable && courtier.responsable.trim())
            || [courtier?.gerant?.nom, courtier?.gerant?.prenom].filter(Boolean).join(' ').trim()
            || "");
        setContacts([
            courtier?.telephone1Agence || courtier?.contact?.[0] || "",
            courtier?.telephone2Agence || courtier?.contact?.[1] || "",
        ]);
    }, [courtier]);

    // ?? et non || : 0 (exonéré) est un vrai taux.
    useEffect(() => {
        setTauxRetenue(estPool ? tauxPool : (tauxCompagnie ?? tauxPool));
    }, [estPool, tauxPool, tauxCompagnie]);

    const saveTauxRetenue = () => {
        if (!courtier?.codeId) return;
        setSavingTaux(true);
        axiosInstance
            .put(`/api/agence/${courtier.codeId}/taux-retenue/${tauxRetenue}`)
            .then((res) => { toast.success(res.data?.message || "Taux de retenue fiscale mis à jour"); setSavingTaux(false); })
            .catch((err) => {
                toast.error(err?.response?.status === 403
                    ? "Réservé à l'administrateur du siège, et la convention avec ce courtier doit être validée."
                    : "Erreur lors de la mise à jour du taux");
                setSavingTaux(false);
            });
    };

    const saveCommissionBase = (checked) => {
        if (!courtier?.codeId) return;
        setSavingComm(true);
        setCommAccessoires(checked);
        axiosInstance
            .put(`/api/agence/${courtier.codeId}/commission-accessoires/${checked}`)
            .then(() => toast.success("Base de commission mise à jour"))
            .catch(() => { toast.error("Erreur lors de la mise à jour"); setCommAccessoires(!checked); })
            .finally(() => setSavingComm(false));
    };

    const saveResponsable = () => {
        if (!courtier?.codeId) return;
        setSavingResp(true);
        axiosInstance
            .put(`/api/agence/${courtier.codeId}/responsable`, null, { params: { responsable: responsable.trim() } })
            .then(() => { toast.success("Responsable mis à jour"); setEditingResp(false); })
            .catch(() => toast.error("Erreur lors de la mise à jour du responsable"))
            .finally(() => setSavingResp(false));
    };

    const saveContacts = () => {
        if (!courtier?.codeId) return;
        setSavingContacts(true);
        const list = contacts.map((c) => (c || "").trim()).filter(Boolean);
        axiosInstance
            .put(`/api/agence/${courtier.codeId}/contacts`, list)
            .then(() => { toast.success("Contacts mis à jour"); setEditingContacts(false); })
            .catch(() => toast.error("Erreur lors de la mise à jour des contacts"))
            .finally(() => setSavingContacts(false));
    };
    return (
        <Card
            style={{
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                border: 'none'
            }}
        >
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                <Avatar
                    size={100}
                    style={{
                        background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                        fontSize: '40px',
                        fontWeight: 700,
                        marginBottom: '16px'
                    }}
                >
                    {courtier?.nom?.charAt(0)}
                </Avatar>
                <h3 style={{
                    margin: '12px 0 4px 0',
                    color: '#242166',
                    fontSize: '20px',
                    fontWeight: 700
                }}>
                    {courtier?.nom}
                </h3>
                <Tag
                    color={courtier?.restrictionProduction ? 'red' : 'green'}
                    style={{
                        borderRadius: '6px',
                        padding: '4px 12px',
                        fontSize: '14px',
                        fontWeight: 500
                    }}
                >
                    {courtier?.restrictionProduction ? 'Inactif' : 'Actif'}
                </Tag>
            </div>

            <Row gutter={[16, 16]} style={{ marginBottom: '32px' }}>
                <Col span={12}>
                    <Card
                        style={{
                            background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                            borderRadius: '12px',
                            border: 'none',
                            textAlign: 'center'
                        }}
                    >
                        <UserOutlined style={{ fontSize: '32px', color: 'white' }} />
                        <Statistic
                            value={courtier?.affairesCount}
                            valueStyle={{
                                color: 'white',
                                fontSize: '24px',
                                fontWeight: 700,
                                marginTop: '8px'
                            }}
                            suffix={<span style={{ fontSize: '14px' }}>Affaires</span>}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card
                        style={{
                            background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                            borderRadius: '12px',
                            border: 'none',
                            textAlign: 'center'
                        }}
                    >
                        <DollarOutlined style={{ fontSize: '32px', color: 'white' }} />
                        <Statistic
                            value={courtier?.commissionsTotal}
                            valueStyle={{
                                color: 'white',
                                fontSize: '18px',
                                fontWeight: 700,
                                marginTop: '8px'
                            }}
                            suffix={<span style={{ fontSize: '12px' }}>FCFA</span>}
                        />
                    </Card>
                </Col>
            </Row>

            <Divider style={{ margin: '24px 0' }} />

            {/* Taux de retenue fiscale : par défaut (Pool) ou celui de la compagnie connectée */}
            <Card size="small" style={{ borderRadius: 10, marginBottom: 16, background: '#f5f7fa' }}>
                <div style={{ color: '#8c8c8c', fontSize: 12, fontWeight: 500, marginBottom: 6 }}>
                    {estPool ? "TAUX DE RETENUE FISCALE (PAR DÉFAUT, TOUTES COMPAGNIES)" : "TAUX DE RETENUE FISCALE (VOTRE COMPAGNIE)"}
                </div>
                {!estPool && tauxCompagnie == null && (
                    <div style={{ color: '#8c8c8c', fontSize: 12, marginBottom: 6 }}>
                        Votre compagnie suit le taux du Pool ({tauxPool === 0 ? "exonéré" : `${tauxPool} %`}).
                    </div>
                )}
                <Space>
                    <Select
                        style={{ width: 160 }}
                        value={tauxRetenue}
                        onChange={setTauxRetenue}
                        disabled={!canEditTaux}
                        options={[
                            { label: 'Exonéré (0 %)', value: 0 },
                            { label: '3 %', value: 3 },
                            { label: '5 %', value: 5 },
                            { label: '20 %', value: 20 },
                        ]}
                    />
                    {canEditTaux && (
                        <Button type="primary" icon={<SaveOutlined />} loading={savingTaux} onClick={saveTauxRetenue}
                            style={{ background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)', border: 'none' }}>
                            Enregistrer
                        </Button>
                    )}
                </Space>
            </Card>

            {/* Base de calcul de la commission (modifiable par le siège) */}
            <Card size="small" style={{ borderRadius: 10, marginBottom: 16, background: '#f5f7fa' }}>
                <div style={{ color: '#8c8c8c', fontSize: 12, fontWeight: 500, marginBottom: 6 }}>
                    BASE DE CALCUL DE LA COMMISSION
                </div>
                <Space>
                    <Switch
                        checked={commAccessoires}
                        loading={savingComm}
                        onChange={saveCommissionBase}
                    />
                    <span style={{ color: '#262626' }}>
                        {commAccessoires ? 'Prime nette + accessoires' : 'Prime nette seule'}
                    </span>
                </Space>
            </Card>

            <div style={{ padding: '0 8px' }}>
                <h4 style={{
                    color: '#242166',
                    fontSize: '16px',
                    fontWeight: 700,
                    marginBottom: '20px'
                }}>
                    Informations détaillées
                </h4>

                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            RESPONSABLE
                        </div>
                        <div style={{ color: '#262626', fontWeight: 500 }}>
                            {editingResp ? (
                                <Space.Compact style={{ width: '100%' }}>
                                    <Input value={responsable} onChange={(e) => setResponsable(e.target.value)}
                                        placeholder="Nom du responsable" onPressEnter={saveResponsable} autoFocus />
                                    <Button type="primary" icon={<SaveOutlined />} loading={savingResp} onClick={saveResponsable} />
                                    <Button onClick={() => { setEditingResp(false); setResponsable((courtier?.responsable && courtier.responsable.trim()) || [courtier?.gerant?.nom, courtier?.gerant?.prenom].filter(Boolean).join(' ').trim() || ""); }}>Annuler</Button>
                                </Space.Compact>
                            ) : (
                                <span>
                                    <UserOutlined style={{ marginRight: '8px', color: '#242166' }} />
                                    {responsable || '—'}
                                    {canEditInfos && (
                                        <EditOutlined style={{ marginLeft: 8, color: '#1890ff', cursor: 'pointer' }}
                                            onClick={() => setEditingResp(true)} />
                                    )}
                                </span>
                            )}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            EMAIL
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <MailOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.email}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            CONTACTS
                        </div>
                        <div style={{ color: '#262626', fontWeight: 500 }}>
                            {editingContacts ? (
                                <Space direction="vertical" style={{ width: '100%' }} size={6}>
                                    <Input value={contacts[0]} onChange={(e) => setContacts([e.target.value, contacts[1]])} placeholder="Téléphone 1" />
                                    <Input value={contacts[1]} onChange={(e) => setContacts([contacts[0], e.target.value])} placeholder="Téléphone 2 (optionnel)" />
                                    <Space>
                                        <Button type="primary" icon={<SaveOutlined />} loading={savingContacts} onClick={saveContacts}>Enregistrer</Button>
                                        <Button onClick={() => { setEditingContacts(false); setContacts([courtier?.contact?.[0] || "", courtier?.contact?.[1] || ""]); }}>Annuler</Button>
                                    </Space>
                                </Space>
                            ) : (
                                <span>
                                    <PhoneOutlined style={{ marginRight: '8px', color: '#242166' }} />
                                    {contacts[0] || '—'}
                                    {contacts[1] && <div style={{ marginLeft: '24px', marginTop: '4px' }}>{contacts[1]}</div>}
                                    {canEditInfos && (
                                        <EditOutlined style={{ marginLeft: 8, color: '#1890ff', cursor: 'pointer' }}
                                            onClick={() => setEditingContacts(true)} />
                                    )}
                                </span>
                            )}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            SIÈGE SOCIAL
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <BankOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.ville}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            SITE WEB
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            <GlobalOutlined style={{ marginRight: '8px', color: '#242166' }} />
                            {courtier?.website}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            NIF
                        </div>
                        <div style={{
                            color: '#262626',
                            fontWeight: 500
                        }}>
                            {courtier?.nif}
                        </div>
                    </div>

                    <div>
                        <div style={{
                            color: '#8c8c8c',
                            fontSize: '12px',
                            marginBottom: '4px',
                            fontWeight: 500
                        }}>
                            TAUX DE COMMISSION
                        </div>
                        <div>
                            {(() => {
                                // Groupé PAR COMPAGNIE, dédoublonné (1 agrément/compagnie le plus récent,
                                // 1 taux/catégorie), avec statut de validation : seul le taux VALIDÉ par la
                                // compagnie est réellement appliqué (cf. backend findTauxCommission…).
                                const isPool = LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL";
                                const myOrgCode = LOGGED_USER?.profil?.organisme?.code;
                                const validatedIds = new Set((courtier?.validAgrements || []).map((a) => a.agreementId));
                                const byComp = new Map();
                                (courtier?.agrements || []).forEach((a) => {
                                    const code = a?.compagnie?.code; if (!code) return;
                                    const prev = byComp.get(code);
                                    if (!prev || (a.agreementId || 0) > (prev.agreementId || 0)) byComp.set(code, a);
                                });
                                (courtier?.validAgrements || []).forEach((a) => {
                                    const code = a?.compagnie?.code; if (!code) return;
                                    if (!byComp.has(code)) byComp.set(code, a);
                                });
                                let groups = [...byComp.values()].map((a) => {
                                    const seen = new Set();
                                    const taux = (a?.tauxCommission || []).filter((tc) => {
                                        const k = tc?.categorie?.codeCategorie;
                                        if (!k || seen.has(k)) return false; seen.add(k); return true;
                                    });
                                    return { compagnie: a?.compagnie, validated: validatedIds.has(a.agreementId), taux };
                                });
                                if (!isPool) groups = groups.filter((g) => g.compagnie?.code === myOrgCode);
                                groups.sort((x, y) => (x.compagnie?.raisonSociale || "").localeCompare(y.compagnie?.raisonSociale || ""));
                                if (!groups.length) return <span style={{ color: '#8c8c8c' }}>Aucun taux</span>;
                                return groups.map((g) => (
                                    <div key={g.compagnie?.code} style={{ marginBottom: 10 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4, flexWrap: 'wrap' }}>
                                            <u style={{ fontWeight: 600 }}>{g.compagnie?.raisonSociale || g.compagnie?.code}</u>
                                            {g.validated
                                                ? <Tag color="green" style={{ borderRadius: 6 }}>✓ Validé</Tag>
                                                : <Tag color="orange" style={{ borderRadius: 6 }}>⏳ En attente de validation</Tag>}
                                        </div>
                                        {g.taux.length ? g.taux.map((tc) => (
                                            <Tag
                                                key={tc?.codeId || tc?.categorie?.codeCategorie}
                                                color={g.validated ? '#242166' : 'default'}
                                                style={{
                                                    margin: '4px 4px 4px 0', borderRadius: '6px', padding: '4px 8px',
                                                    ...(g.validated ? {} : { color: '#8c8c8c', borderStyle: 'dashed' }),
                                                }}
                                            >
                                                {tc?.categorie?.nom} : {tc?.taux}%
                                            </Tag>
                                        )) : <span style={{ color: '#8c8c8c' }}>Non défini</span>}
                                    </div>
                                ));
                            })()}
                        </div>
                    </div>
                </Space>

                <Button
                    type="primary"
                    block
                    size="large"
                    icon={<EditOutlined />}
                    onClick={() => setTCModalOpen(true)}
                    style={{
                        marginTop: '24px',
                        background: 'linear-gradient(135deg, #242166 0%, #1890ff 100%)',
                        border: 'none',
                        borderRadius: '8px',
                        height: '44px',
                        fontWeight: 600
                    }}
                >
                    Gérer les taux de commission
                </Button>
            </div>
        </Card>
    )
}

export default CourtierProfil